var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMerchantAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400,
    fill: "#E1E4EA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bdi_2169_22499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.751 294.2V317.75H82.2513V294.2H94.0263V214.625C86.7773 209.786 80.8349 203.233 76.7267 195.546C72.6185 187.86 70.4715 179.278 70.4763 170.563C70.4763 160.825 73.1139 151.44 77.9299 143.445L109.864 88.1375C110.897 86.3475 112.384 84.8611 114.174 83.8276C115.963 82.7942 117.994 82.2501 120.061 82.25H279.954C282.02 82.2501 284.051 82.7942 285.841 83.8276C287.631 84.8611 289.117 86.3475 290.151 88.1375L321.967 143.268C328.991 154.936 331.249 168.861 328.271 182.151C325.293 195.44 317.308 207.071 305.976 214.625V294.2H317.751ZM126.867 105.8L98.2182 155.408C95.4343 162.286 95.3508 169.962 97.9843 176.9C100.618 183.837 105.774 189.524 112.421 192.822C119.068 196.12 126.715 196.786 133.833 194.687C140.95 192.588 147.012 187.879 150.805 181.501C154.75 171.646 168.703 171.646 172.66 181.501C174.842 186.97 178.613 191.659 183.487 194.962C188.361 198.264 194.114 200.03 200.001 200.03C205.889 200.03 211.642 198.264 216.515 194.962C221.389 191.659 225.161 186.97 227.343 181.501C231.288 171.646 245.241 171.646 249.197 181.501C250.725 185.263 253.015 188.668 255.922 191.502C258.83 194.336 262.292 196.538 266.091 197.969C269.891 199.401 273.945 200.031 278 199.82C282.054 199.609 286.021 198.561 289.652 196.743C293.282 194.925 296.497 192.376 299.094 189.256C301.692 186.135 303.616 182.511 304.746 178.612C305.875 174.712 306.186 170.621 305.658 166.595C305.13 162.569 303.775 158.696 301.678 155.22L273.124 105.8H126.879H126.867Z",
    fill: "white",
    fillOpacity: 0.8,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bdi_2169_22499",
    x: 62.5769,
    y: 74.3506,
    width: 274.875,
    height: 251.399,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3.94969
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2169_22499"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_2169_22499",
    result: "effect2_dropShadow_2169_22499"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2169_22499",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.94969
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.97484
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_2169_22499"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerchantAvatar);
export default __webpack_public_path__ + "static/media/merchant_avatar.de506c65bc647381442e0433ba1e31d1.svg";
export { ForwardRef as ReactComponent };